import { isPushPermissionsAsked, WebpushApiData } from 'helpers/pushes/webpush';

import { httpClient } from './httpClient';

export enum WebpushErrorTypes {
  ShowPopupError = 4,
  SubscribeError = 5,
}

export const WebpushApi = {
  subscribe(payload: { token: string }) {
    return httpClient.post('/webpush/subscribe', payload, {
      params: { ts_ms: Date.now() },
    });
  },

  trackClickAllow() {
    return httpClient.get('/webpush/subscribe/click-allow', {
      params: { ts_ms: Date.now() },
    });
  },

  trackError({
    message,
    webpushesApiData,
    operation,
  }: {
    message: string;
    webpushesApiData: WebpushApiData;
    operation: WebpushErrorTypes;
  }) {
    return httpClient.post(
      `/webpush/subscribe/error/${operation}`,
      {
        message,
        ...webpushesApiData,
        pushAsked: isPushPermissionsAsked(),
      },
      { params: { ts_ms: Date.now() } }
    );
  },

  trackShow() {
    return httpClient.get('/webpush/subscribe/show', {
      params: { ts_ms: Date.now() },
    });
  },

  trackDecline() {
    return httpClient.get('/webpush/subscribe/decline', {
      params: { ts_ms: Date.now() },
    });
  },

  trackClose() {
    return httpClient.get('/webpush/subscribe/close', {
      params: { ts_ms: Date.now() },
    });
  },

  refreshToken() {
    return httpClient.get('/webpush/subscribe/refresh', {
      params: { ts_ms: Date.now() },
    });
  },
};
